export const BUSINESS_FORMATION_PATH = "business-formation";

export const HTSL_SITE_CONFIGURATION = {
	[BUSINESS_FORMATION_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
};
